import React, { useState, useRef } from 'react';
import { X, Check, Globe } from 'lucide-react';
import './SearchEngineModal.css';

const SearchEngineModal = ({ isOpen, onClose, availableEngines, selectedIds, onToggle, onAddCustomEngine }) => {
  const [customUrl, setCustomUrl] = useState('');
  const scrollRef = useRef(null);

  if (!isOpen) return null;

  const MAX_SELECT = 6;
  const currentCount = selectedIds.length;

  const handleAddCustom = (e) => {
    if (e.key === 'Enter' && customUrl.trim()) {
      if (currentCount >= MAX_SELECT && !selectedIds.includes(customUrl)) {
        alert(`最多选择${MAX_SELECT}个搜索引擎，请先取消部分已选项。`);
        return;
      }
      onAddCustomEngine(customUrl.trim());
      setCustomUrl('');
    }
  };

  return (
    <div className="se-modal-overlay">
      <div 
        className="se-modal-container" 
        onClick={e => e.stopPropagation()}
        onWheel={e => e.stopPropagation()}
      >
        <div 
          className="se-modal-header"
          onWheel={(e) => {
            if (scrollRef.current) {
              scrollRef.current.scrollTop += e.deltaY;
            }
          }}
        >
          <div className="se-modal-title">添加搜索引擎</div>
          <div className="se-modal-subtitle">最多添加{MAX_SELECT}种，已添加{currentCount}种</div>
          <button className="se-modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        
        <div className="se-modal-body custom-scrollbar" ref={scrollRef}>
          <div className="se-modal-grid">
            {availableEngines.map(engine => {
              const isSelected = selectedIds.includes(engine.id);
              return (
                <div 
                  key={engine.id} 
                  className={`se-modal-item ${isSelected ? 'selected' : ''}`}
                  onClick={() => {
                    if (!isSelected && currentCount >= MAX_SELECT) {
                      alert(`最多选择${MAX_SELECT}个搜索引擎，请先取消部分已选项。`);
                      return;
                    }
                    onToggle(engine.id);
                  }}
                >
                  <div className="se-modal-item-left">
                    <img src={engine.icon} alt={engine.name} className="se-modal-icon" />
                    <div className="se-modal-item-info">
                      <div className="se-modal-item-name">{engine.name}</div>
                      <div className="se-modal-item-url">{engine.url || engine.searchUrl || '默认搜索地址'}</div>
                    </div>
                  </div>
                  <div className="se-modal-item-right">
                    {isSelected ? (
                      <div className="se-modal-check selected"><Check size={14} /></div>
                    ) : (
                      <div className="se-modal-check empty"></div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="se-custom-engine-section">
            <div className="se-custom-engine-title">自定义搜索引擎</div>
            <div className="se-custom-engine-input-wrapper">
              <Globe className="se-custom-engine-icon" size={16} />
              <input 
                type="text" 
                className="se-custom-engine-input"
                placeholder="请输入搜索地址，用%s代替关键词，例：https://www.baidu.com/s?wd=%s"
                value={customUrl}
                onChange={e => setCustomUrl(e.target.value)}
                onKeyDown={handleAddCustom}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchEngineModal;
